import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  resetFilters() {
    window.location.replace(this.element.dataset.resetUrl);
  }
}